// extracted by mini-css-extract-plugin
module.exports = {"text":"_3_donationInfo_text_3qQe2","checkBoxRadioWrap":"_3_donationInfo_checkBoxRadioWrap_1MC2k"};
    if(module.hot) {
      // 1789136760111
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  